// extracted by mini-css-extract-plugin
export var ticker = "ticker-module--ticker--3kBLW";
export var item = "ticker-module--item--XKY0w";